import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isLoggedIn()) {
        router.navigate(['/login']);
        return false;
    }

    const requiredRoles: string[] = route.data?.['roles'];
    if (requiredRoles && requiredRoles.length > 0) {
        const userRoles = authService.getRoles();
        const hasRole = requiredRoles.some(role => userRoles.includes(role));
        if (!hasRole) {
            router.navigate(['/access']);
            return false;
        }
    }

    return true;
};
